<template>
  <div>
    <h3 class="uppercase text-gray-700">
      Reviewing Country-Specific Health Information:
    </h3>
    <p>{{ description }}</p>
    <ol class="mt-4 mb-6 ml-6 list-decimal">
      <li>
        Visit
        <a
          href="http://wwwnc.cdc.gov/travel/"
          :class="`${secondaryColorClassLinks} font-semibold hover:underline`"
          target="_blank"
          >http://wwwnc.cdc.gov/travel/</a
        >
      </li>
      <li>
        Select your host country from the drop-down menu in the "For Travelers"
        section.
      </li>
      <li>
        Scroll down to the Vaccines and Medicines section under the country map.
      </li>
      <li>
        Copy and paste into the box here the first sentence under the Vaccines
        and Medicines section.
      </li>
    </ol>
    <ApiTextArea
      name="countrySpecificHealth"
      :typed-text="typedText"
      :validation-errors="v$.value.textarea"
      @textUpdate="onFieldChange('textarea', $event)"
    />
  </div>
</template>
<script>
import formInputs from "../../mixins/formInputs";
import ApiTextArea from "../forms/SharedComponents/ApiTextArea";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { COUNTRY_SPECIFIC_INFO_TEXT } from "./constants";
export default {
  name: "CountrySpecificInfo",
  components: { ApiTextArea },
  mixins: [formInputs],
  props: {
    countryInfo: {
      type: [Object, String],
      default: function () {
        return {};
      },
    },
  },
  emits: ["update:country-info"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      value: {
        textarea: "",
      },
      description: COUNTRY_SPECIFIC_INFO_TEXT,
    };
  },
  watch: {
    value: {
      handler: function () {
        this.$emit("update:country-info", this.value);
      },
      deep: true,
      immediate: true,
    },
  },

  validations: {
    value: {
      textarea: {
        required,
      },
    },
  },
};
</script>
